enum ActionType {
    REQUEST_ETS = '[DASHBOARD/ETS_VALUE] GET VALUE',
    RECEIVE_ETS = '[DASHBOARD/ETS_VALUE] SET VALUE',
}

export default ActionType
